/**
 * Checks if the user has given consent to all cookies using OneTrust.
 *
 * @returns {boolean} - Returns true if the user has given consent to all cookies, otherwise false.
 */
export function checkOneTrustConsent() {
    /**
     * @note OneTrust is adding cookies by group to OnetrustActiveGroups or to OptanonActiveGroups array.
     * If that array contains less than 4 items - User didn't accept all cookies.
     */
    if (!window.OnetrustActiveGroups && !window.OptanonActiveGroups) {
        return false;
    }

    return (
        window.OnetrustActiveGroups?.split(',').filter((item) => item.length)
            .length >= 4 ||
        window.OptanonActiveGroups?.split(',').filter((item) => item.length)
            .length >= 4
    );
}
